import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { isIP } from "./utils";

export function RecaptchaRow(props) {
  const { show, setRecaptcha, setRecaptchaInstance, recaptchaExtra } = props;

  if (!show) {
    return null;
  }

  const sitekey = getRecaptchaSiteKey();
  if (sitekey === "localsite") {
    return null;
  }

  return (
    <div className="row mb-1">
      <div className="col-sm-6">
        <ReCAPTCHA
          ref={(e) => {
            setRecaptchaInstance(e);
          }}
          sitekey={sitekey}
          // render="explicit"
          onChange={(response) => {
            console.log("recaptcha changed", response);
            setRecaptcha(response);
          }}
        />
      </div>
      <div className="col-sm-6">{recaptchaExtra}</div>
    </div>
  );
}

export function ReloadRecaptcha(props) {
  const { setRecaptchaInstance, recaptchaInstance, hide } = props;

  if (hide || !recaptchaInstance) {
    return null;
  }

  return (
    <div className="m-0 p-0 mb-3">
      <span
        style={{ cursor: "pointer" }}
        onClick={() => {
          recaptchaInstance.reset();
          setRecaptchaInstance(null);
        }}
      >
        Reload reCaptcha
      </span>
    </div>
  );
}

export const getRecaptchaSiteKey = () => {
  if (isIP(window.location.hostname)) {
    // return "6LfJt4sUAAAAAIGNjKs8OeA3gmDAYXmeiUHMtp2o";
    return "localsite";
  }
  // Default site key for sustainabilitytool.com
  return "6LfJt4sUAAAAAIGNjKs8OeA3gmDAYXmeiUHMtp2o";
};
